<template>
  <q-card class="veneer-log" square flat bordered>
    <q-card-section class="q-pa-none">
      <router-link :to="detailLink" v-if="!emitLog">
        <log-teaser :log="log" :watchlist-item="watchlistItem" :is-public="isPublic"/>
      </router-link>
      <a @click="$emit('click', log)" v-else>
        <log-teaser :log="log" :watchlist-item="watchlistItem" :is-public="isPublic"/>
      </a>
    </q-card-section>

    <q-card-section class="veneer-log-info-section q-py-none">
      <veneer-log-info :log="log" :is-public="isPublic" :virtual="virtual" dense>
        <slot name="additionalInfo"/>
      </veneer-log-info>
    </q-card-section>

    <q-separator/>

    <div class="row justify-start q-col-gutter-sm q-pa-sm veneer-card-buttons">
      <div class="col-4">
        <q-btn color="primary"
               size="11px"
               :to="detailLink"
               icon="visibility"
               no-caps no-wrap
               :label="$t('button.detailView')"
        />
      </div>
      <div class="col-4">
        <q-btn v-if="measurementListDialog"
               text-color="primary"
               size="11px"
               @click="showMeasurementListDialog(log, virtual, watchlistItem)"
               icon="img:\typo3conf\ext\ig_warehouse\Resources\Public\Icons\tally-sheet.png"
               no-caps no-wrap flat
               :label="$t('button.measurementList')"
        />
      </div>
      <div class="col-4">
        <q-btn v-if="watchlistDialog && user && !isPublic"
               text-color="primary"
               size="11px"
               @click="showWatchlistDialog(log, virtual)"
               :icon="watchIcon"
               no-caps no-wrap flat
               :label="$t('button.watch')"
        />
      </div>

      <slot v-if="user" name="additionalActions"/>

      <template v-if="user && (virtualLog && !virtual || !isPublic && virtual)">
        <div class="col-4">
          <q-btn v-if="virtualLog && !virtual" text-color="primary" size="11px" @click="addToVirtualLog(log)" icon="add"
                 no-caps no-wrap flat :label="$t('button.addToVirtualLog')"/>
        </div>
        <div class="col-4">
          <q-btn v-if="virtual" text-color="primary" size="11px" @click="editVirtualLog(log, watchlistItem)" icon="edit"
                 no-caps no-wrap flat :label="$t('button.edit')"/>
        </div>
      </template>
    </div>
  </q-card>
</template>

<script>
import VeneerLogInfo from "@/components/common/VeneerLogInfo";
import {mapGetters} from 'vuex';
import LogPropertiesResolver from "@/mixins/LogPropertiesResolver";
import MeasurementListDialogOpener from "@/mixins/MeasurementListDialogOpener";
import WatchlistDialogOpener from "@/mixins/WatchlistDialogOpener";
import {
  ADD_TO_VIRTUAL_LOG,
  SET_VIRTUAL_LOG,
  SET_VIRTUAL_LOG_EDIT_MODE,
  SET_VIRTUAL_LOG_WATCHLIST_ITEM
} from "@/store/mutations.type";
import LogTeaser from "@/components/common/element/LogTeaser";
import LogUtility from "@/mixins/LogUtility";
import woodtypes from "@/common/woodtypes";
import WatchlistLogUtility from "@/mixins/WatchlistLogUtility";

export default {
  name: "VeneerLog",
  mixins: [LogPropertiesResolver, WatchlistDialogOpener, MeasurementListDialogOpener, LogUtility, WatchlistLogUtility],
  components: {LogTeaser, VeneerLogInfo},
  props: ['log', 'watchlistItem', 'measurementListDialog', 'watchlistDialog', 'showActiveWatchlistCheck', 'virtual', 'isPublic', 'isDynamicWatchlist', 'emitLog'],
  computed: {
    ...mapGetters(['watchlist', 'watchlistLogIds', 'virtualLog', 'user']),
    detailLink() {
      let route = 'detail';

      if (this.watchlistItem) {
        if (this.user) {
          route = 'watchlistItemDetail';
        } else {
          route = 'watchlistItemSharedDetail';
        }
      } else if (this.isDynamicWatchlist && !this.user) {
        route = 'dynamicWatchlistItemDetail';
      }

      return {
        name: route,
        params: {
          identifier: this.watchlistItem ? this.watchlistItem.uid : this.logId,
          hash: this.watchlistItem || this.isDynamicWatchlist ? this.watchlist.permalinkHash : "",
          propLog: this.log
        }
      };
    }
  },
  methods: {
    async addToVirtualLog(log) {
      await this.$store.commit(ADD_TO_VIRTUAL_LOG, {log, snack: true});
    },
    editVirtualLog(log, watchlistItem) {
      this.$store.commit(SET_VIRTUAL_LOG_EDIT_MODE, true);

      // do not reset log editing when the log is already being edited
      if (this.virtualLog &&
          watchlistItem.itemType === woodtypes.VIRTUAL &&
          this.virtualLog.uid === log.uid
      ) {
        return;
      }

      this.$store.commit(SET_VIRTUAL_LOG, log);
      this.$store.commit(SET_VIRTUAL_LOG_WATCHLIST_ITEM, watchlistItem);
    }
  }
}
</script>

<style lang="scss">
.veneer-log {
  transition: box-shadow 0.5s ease;
  max-width: 600px;
  margin: 0 auto;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.9) !important;
  }

  a {
    cursor: pointer;
  }

  .veneer-card-buttons {
    button {
      width: 100%;
    }

    i, img {
      margin-right: 4px;
    }
  }
}

@media(max-width: 899px) {
  .veneer-log .veneer-log-info-section {
    .q-item, .extended-info-list {
      padding: 0 !important;
    }
  }
}
</style>